import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpRightChevronCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.343 2.343a8 8 0 1 0 11.314 11.314A8 8 0 0 0 2.343 2.343M8 12.95l3.182-3.182v-4.95h-4.95L3.05 8H8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpRightChevronCircle
